/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 精算書生成用データソース start_at, end_at, issued_at はoperationで共通のため個別には書かない
 * @export
 * @interface BatchRunResultStatementSourceInner
 */
export interface BatchRunResultStatementSourceInner {
    /**
     * actualFare の合計(赤黒区分なし)
     * @type {number}
     * @memberof BatchRunResultStatementSourceInner
     */
    subtotalAmount: number;
    /**
     * 税額合計(内税)
     * @type {number}
     * @memberof BatchRunResultStatementSourceInner
     */
    taxAmount: number;
    /**
     * 
     * @type {string}
     * @memberof BatchRunResultStatementSourceInner
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof BatchRunResultStatementSourceInner
     */
    companyName: string;
}

/**
 * Check if a given object implements the BatchRunResultStatementSourceInner interface.
 */
export function instanceOfBatchRunResultStatementSourceInner(value: object): value is BatchRunResultStatementSourceInner {
    if (!('subtotalAmount' in value) || value['subtotalAmount'] === undefined) return false;
    if (!('taxAmount' in value) || value['taxAmount'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    return true;
}

export function BatchRunResultStatementSourceInnerFromJSON(json: any): BatchRunResultStatementSourceInner {
    return BatchRunResultStatementSourceInnerFromJSONTyped(json, false);
}

export function BatchRunResultStatementSourceInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchRunResultStatementSourceInner {
    if (json == null) {
        return json;
    }
    return {
        
        'subtotalAmount': json['subtotal_amount'],
        'taxAmount': json['tax_amount'],
        'companyId': json['company_id'],
        'companyName': json['company_name'],
    };
}

export function BatchRunResultStatementSourceInnerToJSON(json: any): BatchRunResultStatementSourceInner {
    return BatchRunResultStatementSourceInnerToJSONTyped(json, false);
}

export function BatchRunResultStatementSourceInnerToJSONTyped(value?: BatchRunResultStatementSourceInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subtotal_amount': value['subtotalAmount'],
        'tax_amount': value['taxAmount'],
        'company_id': value['companyId'],
        'company_name': value['companyName'],
    };
}

